var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11430_129898)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7778 12.0004C19.8207 10.7966 20.4989 9.69909 21.5726 9.09588C21.7009 9.01144 21.8291 8.97133 21.9574 8.88859L20.8891 7.02132L19.7778 5.15363L19.3913 5.40271C18.313 6.01723 16.9806 6.03328 15.887 5.44493C14.8195 4.80651 14.1723 3.67368 14.1796 2.45637C14.1728 2.30304 14.1874 2.14952 14.223 2H9.77783C9.77783 2.12454 9.8213 2.29045 9.8213 2.45637C9.81723 3.67115 9.17186 4.79903 8.11174 5.44408C7.01324 6.01143 5.69266 5.99583 4.6087 5.40271C4.47403 5.32942 4.34538 5.24615 4.22391 5.15363L3.1113 7.0209L2 8.88817C2.13681 8.9411 2.26612 9.01076 2.38478 9.09545C3.45845 9.69872 4.13663 10.7962 4.17957 12C4.13663 13.2038 3.45845 14.3013 2.38478 14.9045C2.25652 14.989 2.12826 15.0291 2 15.1118L3.1113 16.9791L4.22261 18.8464L4.6087 18.5981C5.68702 17.9836 7.01935 17.9676 8.11304 18.5559C9.18106 19.1937 9.82909 20.3262 9.82261 21.5436C9.82937 21.697 9.81474 21.8505 9.77913 22H14.2222C14.2222 21.8755 14.1787 21.7095 14.1787 21.5436C14.1828 20.3289 14.8281 19.201 15.8883 18.5559C16.9873 17.9884 18.3085 18.0043 19.3926 18.5981L19.7774 18.8472L20.8887 16.9799L22 15.1127C21.8632 15.0597 21.7339 14.9901 21.6152 14.9054C20.518 14.3194 19.8199 13.2156 19.7778 12.0004ZM12 16.1666C9.69879 16.1666 7.83333 14.3011 7.83333 12C7.83333 9.69879 9.69879 7.83333 12 7.83333C14.3011 7.83333 16.1666 9.69879 16.1666 12C16.1742 13.1073 15.7377 14.1716 14.9546 14.9546C14.1716 15.7377 13.1073 16.1742 12 16.1666Z",
    fill: "#7783A1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11430_129898"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSetting);
export default __webpack_public_path__ + "static/media/icon_setting.ae9fc246c6678ef00d4a84f65bd7406c.svg";
export { ForwardRef as ReactComponent };